var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeShipment)?_c('div',{staticClass:"pa-5"},[_c('model-logs-list',{attrs:{"logs":_vm.activeShipment.logs,"include-title":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }